export const LOGO_PATH = '/' + process.env.VUE_APP_SYSTEM_LOGO
export const SYSTEM_BRAND = process.env.VUE_APP_SYSTEM_BRAND_SHRTCT
export const SYSTEM_NAME = process.env.VUE_APP_SYSTEM_NAME

export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_URL = process.env.VUE_APP_BASE_URL;

export const REMOTE_URL = process.env.VUE_APP_REMOTE_URL;

export const TOKEN_VARIABLE = "cnc_acctg_token";
export const EXPIRY_TOKEN_VARIABLE = "cnc_acctg_token_expiry";
export const USER_INFO_VARIABLE = "cnc_acctg_user_info";

export const SALUTATIONS = {
    mr: 'Mr',
    ms: 'Ms',
    mrs: 'Mrs',
    dr: 'Dr'
}

export const FIELD_STATUS_BOOTSTRAP = {
    0: "",
    1: "is-valid",
    2: "is-invalid"
}

export const ACC_TYPES = {
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Equity',
    income: 'Income',
    expense: 'Expense'
}

export const JOURNAL_STATUSES = {
    draft: 'Draft',
    posted: 'Posted'
}

export const REPORT_FILTERS = {
    'as_of': 'As of',
    'range': 'Range',
    'quarter': 'Quarter',
    'month': 'Month'
}

export const COMPARATIVE_TYPES = {
    'none': 'None',
    'year': 'Year',
    'month': 'Month',
    'quarter': 'Quarter'
}

export const ERROR_MESSAGES = {
    fields_format: 'Please fill in required fields.',
    entry_count: 'Entries cannot be empty. Please add entries.',
    entry_amount: 'Amount must not be less than 0.',
    entries_variance: 'Cannot proceed to save journal. Unbalanced journal cannot be recorded.'
}

export const MODULES = {
    payable: 'Payable',
    receivable: 'Receivable',
    disbursement: 'Payment',
    receipt: 'Receipt',
}

export const SYS_COMPONENTS = {
    acctg_sys: 'Accounting System',
    opt_sys: 'Operations System',
    accounting: 'Accounting',
    journal: 'Journal',
    payables: 'Payables',
    modules: 'Modules',
    pages: 'Modules',
    reports: 'Reports',
    setup: 'Setup'
}

export const ROUTES_PARENT= {
    accounting: ['journals', 'payables', 'paymentsReceipts'],
    reports: ['trialBalance', 'balanceSheet', 'profitAndLoss', 'inventory'],
    setup: ['chartOfAccounts', 'entities', 'accountMappings', 'branches', 'users', 'users']
}